var click_num = 0;
var allowScrollHandler = true;
function waitForGaClientId(callback) {
  if (typeof window.getGaClientId === "function") {
    callback(window.getGaClientId());
  } else {
    setTimeout(() => waitForGaClientId(callback), 100);
  }
}

// 轮询等待，获取 clientId
waitForGaClientId((clientId) => {});

// 检查 localStorage 是否有值
if (localStorage.asShopperInputInfo) {
  email = JSON.parse(localStorage.asShopperInputInfo).email;
}
$(function () {
  const params = new URLSearchParams(window.location.search);
  const key = params.get("q");

  $("#search-key-container #search-key").text(`'${key}'`);
  activeIntelligent_recommend(clientId, email);
});
var scrollThreshold = 200; // 滚动的阈值，每滚动200像素调用一次函数
var jiazai_num = 0;
// 滚动事件处理函数
var lastScrollTop = $(".search-result-header").offset().top - 1000;
function searchScrollEventHandler() {
  if (!allowScrollHandler) {
    return;
  }
  // 获取当前滚动条的位置
  scrollTop = $(window).scrollTop();
  // 判断滚动的距离是否超过阈值，并且是向下滚动
  // 在这里编写原来的滚动事件处理逻辑
  if (
    scrollTop > lastScrollTop &&
    scrollTop - lastScrollTop >= scrollThreshold
  ) {
    jiazai_num += 1;

    // 调用需要执行的函数
    // 更新上次滚动的位置
    if (jiazai_num < 7) {
      lastScrollTop = $(window).scrollTop();
      activeIntelligent_recommend(clientId, email);
    } else {
      return false;
    }
  }
}
// 搜索结果页面智能推荐
function activeIntelligent_recommend(clientId, email) {
  click_num += 1;
  var now = new Date(); // 获取当前日期和时间

  clientId ? clientId : "";
  email ? email : "";
  var form = new FormData();
  form.append("cid", clientId);
  form.append("email", email);
  // ✅ 当前币种（核心）
  const currency =
    window.Shopify?.currency?.active ||
    window.Currency?.currentCurrency ||
    "USD";
  // ===== ② 货币符号（仅展示）=====
  const CURRENCY_SYMBOL_MAP = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    SGD: "S$",
    AUD: "A$",
    CAD: "C$",
    JPY: "¥",
  };
  const currency_symbol = CURRENCY_SYMBOL_MAP[currency] || currency;
  form.append("currency", currency);
  form.append("currency_symbol", currency_symbol);
  form.append("currency_rate", Shopify.currency.rate);
  if (click_num >= 2) {
    product_ids = sessionStorage.getItem("activeRecommend_products_ids");
    card_id = sessionStorage.getItem("activeRecommend_card_id");
    form.append("all_product_id", product_ids);
    form.append("all_cards", card_id);
    form.append("page", click_num);
  }
  $.ajax({
    url: "https://plugin.kriyya.com/api/klaiyi/recommend_activity",
    method: "POST",
    timeout: 0,
    headers: {
      Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
    },
    processData: false,
    mimeType: "multipart/form-data",
    contentType: false,
    data: form,
    success: function (res) {
      //  判断要不要滑动加载
      if (JSON.parse(res).code == 1) {
        if (click_num >= 2) {
          sessionStorage.setItem(
            "recommend_products",
            JSON.parse(res).data.content
          );
          $(".search-result-content .ProductListWrapper .ProductList").append(
            JSON.parse(res).data.content
          );
          var $searchRecommend = $(".search-result-content");
          window.normalizeRecommendProductGalleryMarkup?.($searchRecommend);
          window.initAllProductImageSwipers?.($searchRecommend);
          video_list();
          sessionStorage.setItem(
            "activeRecommend_products_ids",
            JSON.parse(res).data.all_product_id
          );
          sessionStorage.setItem(
            "activeRecommend_card_id",
            JSON.parse(res).data.all_cards
          );
        } else {
          var $searchRecommend = $(".search-result-content");
          $(".search-result-content .ProductListWrapper").html(
            JSON.parse(res).data.content
          );
          window.normalizeRecommendProductGalleryMarkup?.($searchRecommend);
          window.initAllProductImageSwipers?.($searchRecommend);
          video_list();
          sessionStorage.setItem(
            "activeRecommend_products_ids",
            JSON.parse(res).data.all_product_id
          );
          sessionStorage.setItem(
            "activeRecommend_card_id",
            JSON.parse(res).data.all_cards
          );
        }
        // 绑定滚动事件处理函数
        if (click_num <= 7) {
          $(window).scroll(searchScrollEventHandler);
        } else {
          return false;
        }
      } else {
        allowScrollHandler = false;
      }
      if (jQuery(window).width() <= 768) {
        $(".search-result-content .ProductListWrapper .ProductItem").each(
          function () {
            $(this).find(".tag_all_mark .tag_mark:gt(0)").hide();
          }
        );
      }
      $(
        ".search-result-content .ProductListWrapper .ProductItem .addCart_icon"
      ).each(function () {
        $(this)
          .off("click")
          .on("click", function () {
            let $this = $(this);
            if ($this.hasClass("disabled")) return; // 已禁用，不执行

            $this.addClass("disabled"); // 禁用点击
            setTimeout(() => {
              $this.removeClass("disabled"); // 2秒后恢复
            }, 5000);
            if ($(".quick_shop_main").is(":visible")) {
              $this.addClass("disabled"); // 禁用点击
            } else {
              quick_icon_click(
                jQuery(this),
                jQuery(this).parent().siblings().find("a").attr("href")
              );
            }
          });
      });
      $("img.pic_site").each(function () {
        $(this).attr("src", $(this).attr("data-src"));
      });
      var clickTimer = null;
      //  $('#shopify-section-template--15781914968198__36c2ef42-7a11-4457-89ad-da5261c73839 .SectionFooter a').on('click', function (event) {
      //         event.preventDefault();
      //          // 直接将页面滚动到顶部
      //        $('html, body').scrollTop(0);
      //  })
    },
    error: function (req) {
      console.log("错误返回值", req);
    },
  });
}

// 绑定搜索推荐商品视频弹窗（对齐其它推荐页的 video_card）
function video_list() {
  $(".search-result-content .ProductListWrapper .ProductItem_video_img").each(
    function () {
      $(this)
        .off("click")
        .on("click", function () {
          sessionStorage.setItem("popupVisible", "true");
          const product_mes = JSON.parse($(this).attr("data-json"));
          $(".video_product_cen a").attr(
            "href",
            "https://www.klaiyihair.com/products/" + product_mes.handle
          );
          $(".video_product_cen .video_product_left img").attr(
            "src",
            product_mes.featured_image
          );
          $(".video_poupop .video_product_cen").attr(
            "product-id",
            product_mes.product_id
          );
          $(".video_poupop .video_poupop_cen .video_product_title").text(
            product_mes.title
          );
          $(".video_poupop .video_poupop_cen .video_product_now_price").text(
            "$" + (product_mes.price / 100).toFixed(2)
          );
          $(".video_poupop .video_poupop_cen .video_product_old_price").text(
            "$" + (product_mes.compare_at_price / 100).toFixed(2)
          );
          if (jQuery(window).width() > 768) {
            $(".video_poupop .video_poupop_cen video").attr("controls", "");
          }
          $(".video_poupop .video_poupop_cen video").attr(
            "data-video-src",
            $(this).attr("data-video-src")
          );
          $(".video_poupop .video_poupop_cen video").attr(
            "poster",
            $(this).find("picture").find(".cover_pic").attr("src")
          );
          $(".video_poupop .video_poupop_cen source").attr(
            "src",
            $(this).attr("data-video-src")
          );
          $(".video_product_cen a").on("click", function () {
            localStorage.setItem("video_scrol_top", newscrollTop);
            sessionStorage.removeItem("popupVisible");
            var video = $(".video_poupop_cen_con video")[0];
            const $video = $(".video_poupop_cen_con video");
            $video.prop("muted", true);
            $(".video_poupop .muteButton .iconfont")
              .addClass(".icon-Volume-Up")
              .removeClass("icon-Volume");
            $(".video_poupop .muteButton").show();
            $(".video_poupop .playBtn").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552"
            );
            video.pause();
            setTimeout(function () {
              $(".video_poupop .window-cover").css("display", "none");
              $(".video_poupop .video_poupop_cen").css("display", "none");
            }, 2000);
          });
          const $loading = $("#video_loading");
          $loading.show();
          const $video = $(".video_poupop .video_poupop_cen video");
          const video = $(".video_poupop .video_poupop_cen video")[0];
          $video[0].currentTime = 0;
          $(".video_poupop .video_poupop_cen_con .progressBar").css("width", 0);
          $video.prop("muted", true);
          $video[0].load();
          $video[0].addEventListener("loadeddata", function () {
            $loading.hide();
            $video[0].play();
            $(".video_poupop .playBtn").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552"
            );
            var progressBar = $(
              ".video_poupop .video_poupop_cen_con .progressBar"
            );
            var handleProgress = function () {
              var percentage = (100 / video.duration) * video.currentTime;
              if ((video.duration - video.currentTime) / 60 > 1) {
                var min_num = Math.floor(
                  (video.duration - video.currentTime) / 60
                );
                if (min_num < 10) {
                  $(".end_min").text("0" + min_num);
                } else {
                  $(".end_min").text(min_num);
                }
                if (
                  Math.floor(
                    video.duration - min_num * 60 - video.currentTime
                  ) < 10
                ) {
                  $(".end_second").text(
                    "0" +
                      Math.floor(
                        video.duration - min_num * 60 - video.currentTime
                      )
                  );
                } else {
                  $(".end_second").text(
                    Math.floor(
                      video.duration - min_num * 60 - video.currentTime
                    )
                  );
                }
              } else {
                $(".end_min").text("00");
                if (Math.floor(video.duration - video.currentTime) < 10) {
                  $(".end_second").text(
                    "0" + Math.floor(video.duration - video.currentTime)
                  );
                } else {
                  $(".end_second").text(
                    Math.floor(video.duration - video.currentTime)
                  );
                }
              }
              progressBar.css("width", percentage + "%");
            };
            $video[0].addEventListener("timeupdate", handleProgress, false);
          });

          $(".video_poupop .video_product .video_title_cen").text(
            $(this).attr("data-video_name")
          );

          const $text = $(".video_title_cen");
          const $button = $(".video_toggle_button");
          if ($text[0] && $text[0].scrollHeight > $text.outerHeight()) {
            $button.show();
          }
          $button.off("click").on("click", function () {
            $(".video_title").toggleClass("expand");
            $(this).text($(".video_title").hasClass("expand") ? "╱╲" : "╲╱");
          });
          var newscrollTop = $(window).scrollTop();
          if (jQuery(window).width() > 769) {
            $("body").attr("data-overflow-top", newscrollTop);
            $("body").css({
              overflow: "hidden",
              position: "fixed",
              top: "-" + newscrollTop + "px",
              left: "0",
              right: "0",
              bottom: "0",
            });
          }

          $(".video_poupop .window-cover").css("display", "block");
          $(".video_poupop .video_poupop_cen").css("display", "block");
          $(".video_poupop .window-cover_con-close")
            .off("click")
            .on("click", function () {
              $(
                ".video_poupop .window-cover, .video_poupop .video_poupop_cen"
              ).hide();
              if ($(window).width() > 769) {
                var scrollTop = $("body").attr("data-overflow-top");
                $("body").css({
                  overflow: "",
                  position: "",
                  top: "",
                  left: "",
                  right: "",
                  bottom: "",
                  width: "",
                });
                $(window).scrollTop(scrollTop);
              }
            });
        });
    }
  );
}
